import { createAppSlice } from "Data/Redux/Store";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { AiAnalyticsState } from "Interfaces";
import { StaticObjectFilter, TrackReferencePoint } from "Data/Objects/Camera";
import { constant, times } from "lodash";

const initialState: AiAnalyticsState = {
	enabled: false,
	exclusionZones: times(4, (constant(null))),
	rules: times(8, (constant(null))),
	selectedIndex: 1,
	staticObjectFilter: StaticObjectFilter.OFF,
	trackReferencePoint: TrackReferencePoint.CENTER,
	minSizeFilterEnabled: false,
	maxSizeFilterEnabled: false,
	minSizeFilter: [
		{ x: 460, y: 340 },
		{ x: 860, y: 340 },
		{ x: 860, y: 740 },
		{ x: 460, y: 740 }
	],
	maxSizeFilter: [
		{ x: 1060, y: 340 },
		{ x: 1460, y: 340 },
		{ x: 1460, y: 740 },
		{ x: 1060, y: 740 }
	]
};

export const setAiAnalyticsReducer = (state: AiAnalyticsState, action: PayloadAction<AiAnalyticsState>) => {
	return action.payload;
};

export const getAiAnalytics = (state: AiAnalyticsState) => {
	return state;
};

const aiAnalyticsSlice = createAppSlice({
	name: "aiAnalytics",
	initialState,
	reducers: {
		setAiAnalyticsAction: setAiAnalyticsReducer
	},
	selectors: {
		selectAiAnalytics: getAiAnalytics
	}
});

export default aiAnalyticsSlice;

export const { setAiAnalyticsAction } = aiAnalyticsSlice.actions;
export const { selectAiAnalytics } = aiAnalyticsSlice.selectors;
